<template>
  <div>
    <vs-row vs-justify="center" class="mt60">
      <vs-col type="flex" vs-justify="center" vs-align="center" vs-sm="6" vs-lg="4" vs-xs="12">
        <vs-card class="cardx" v-if="screen == '1'">
          <div slot="header">
            <h4>
              Forgot Password
            </h4>
              <img
                size="40px"
                style="
                  float: right;
                  margin-top: -33px;
                  height: 44px;"
                :src="require('@/assets/logo-black.png')"
              />
          </div>
          <vs-row>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input label="Email Id" v-model="send.email" @keypress.enter="btnSendOTP"/>
            </vs-col>
            <vs-col vs-lg="6" vs-xs="6">
              <vs-button @click="btnSendOTP">Send OTP</vs-button>
            </vs-col>
            <vs-col vs-lg="6" vs-xs="6" class="flink">
              <router-link to="/login">Try Login!</router-link>
            </vs-col>
          </vs-row>
        </vs-card>
        <vs-card class="cardx" v-if="screen == '2'">
          <div slot="header">
            <h4>Verify & Set Up New Password</h4>
          </div>
          <vs-row>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input label="Verification Code" v-model="verify.otp" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input label="New Password" type="password" v-model="verify.password" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input label="Confirm Password" type="password" v-model="confirmPassword" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-button @click="btnForgotPassword">Update Password</vs-button>
            </vs-col>
          </vs-row>
        </vs-card>
      </vs-col>
    </vs-row>
    <div class="text-center">
      <small>Powered By - saaslabs.in</small>
    </div>
  </div>
</template>

<script>
import router from "../router.js";
import api from "../rest.js";
import { API } from "../common/constants";
export default {
  name: "ForgotPassword",
  components: {},
  data() {
    return {
      send: {
        email: ""
      },
      verify: {
        email: "",
        password: "",
        otp: "",
      },
      confirmPassword: "",
      screen: "1"
    };
  },
  methods: {
    btnSendOTP() {
      this.$vs.loading();
        api
          .post(API.SEND_OTP, this.$data.send)
          .then(r => {
            this.$vs.loading.close();
            if (r.data.status) {
              this.$data.verify.email = this.$data.send.email;
              this.$vs.notify({
                title: "Verify Account",
                text: "Verification Code Sent to your registered Email Id",
                color: "success",
                position: "top-right"
              });
              this.screen = "2";
            } else {
              this.$vs.notify({
                text: r.data.error,
                color: "danger",
                position: "top-right"
              });
            }
          })
          .catch(() => {
            this.$vs.loading.close();
          });
    },
    btnForgotPassword() {
      if(this.verify.password !== this.confirmPassword){
        this.$vs.notify({
          title: "Password Mismatch",
          text: "Passwords do not match!",
          color: "danger",
          position: "top-right"
        });
        return;
      }
      this.$vs.loading();
      api
        .post(API.FORGOT, this.$data.verify)
        .then(r => {
          this.$vs.loading.close();
          if (r.data.status) {
            router.push("/login");
            this.$vs.notify({
              title: "Password Changed Successfully",
              text: "Successfully password change!",
              color: "success",
              position: "top-right"
            });
            this.screen = "2";
          } else {
            this.$vs.notify({
              title: "ERROR",
              text: r.data.error,
              color: "danger",
              position: "top-right"
            });
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
            this.$vs.notify({
              title: "ERROR",
              text: err.message,
              color: "danger",
              position: "top-right"
            });
        });
    }
  }
};
</script>
<style scoped>
.mt60 {
  margin-top: 60px;
  padding: 30px;
}
.flink {
  text-align: right;
  padding-top: 12px;
}
</style>
